/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { OmitFunctions } from 'src/core/stores/types';

export type CustomTextEntityLabelStoreData = OmitFunctions<Partial<CustomTextEntityLabelStore>>;
export type LabelType = 'autoTagged' | 'gptPredicted' | 'normal';
export class CustomTextEntityLabelStore {
    public entityId: string;

    public startCharIndex: number;

    public endCharIndex: number;

    public labelType?: LabelType;

    constructor(labelData: CustomTextEntityLabelStoreData) {
        this.entityId = labelData.entityId;
        this.startCharIndex = labelData.startCharIndex;
        this.endCharIndex = labelData.endCharIndex;
        this.labelType = labelData.labelType ?? 'normal';
    }
}
